<template>
  <div>
    <b-card>
      <div class="card-header">
          <i class='fa fa-align-justify'></i> Historial de asignaciones
          <div class="pull-right" v-if="visible">
             <b-button variant="primary" size="sm" @click="exportExcel()"> 
                <template v-if="excelLoading == false"><i class="fa fa-download"></i> Exportar historial</template>
                <template v-else><loader :size="'small'" :color="'white'">Exportando</loader></template>
            </b-button>
          </div>
      </div>
      <template v-if="visible">
        <div class="card-block">
            <dx-data-grid
            :dataSource="asignaciones"
            :columns="columns"
            :paging="paging"
            :headerFilter="{ visible: true }"
            :groupPanel="{ visible: true }"
            :allowColumnReordering="true"
            :allowColumnResizing="true"
            :filterRow="{ visible: true }"
            :columnHidingEnabled="true"
            :columnResizingMode="'widget'"
            :summary="summary"
            :pager="{
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20],
                showInfo: true
            }"
            >
                <div slot="Cantidad" slot-scope="data">
                    {{data.data.Timbres | quantity}}
                </div>
            </dx-data-grid>
        </div>
      </template>
      <template v-else>
        <h2 class="text-center">Sin asignaciones.</h2>
      </template>
    </b-card>
  </div>
</template>
<script>
import { DxDataGrid } from 'devextreme-vue'
import moment from 'moment'
import Pagination from '@/views/components/Pagination'
import Loader from '@/components/Loader'
import store from '@/store'

export default {
  name: 'asignaciones',
  props: ['informacion'],
  components: {Pagination, Loader, DxDataGrid},
  data () {
    return {
      summary: {
        totalItems: [{
          column: 'Rfc',
          summaryType: 'count',
          customizeText: function (e) {
            let value
            value = e.value.toString()
            value = String(value).replace(/\D/g, '')
            return value === '' ? value : Number(value).toLocaleString()
          }
        }, {
          column: 'Timbres',
          summaryType: 'sum',
          customizeText: function (e) {
            let value
            value = e.value.toString()
            value = String(value).replace(/\D/g, '')
            return value === '' ? value : Number(value).toLocaleString()
          }
        }]
      },
      paging: {
        pageSize: 20,
        pageIndex: 0
      },
      columns: [{
        dataField: 'Rfc',
        caption: 'RFC',
        width: 120
      }, {
        dataField: 'RazonSocial',
        caption: 'Razón Social',
        width: 350
      }, {
        dataField: 'Timbres',
        caption: 'Cantidad',
        format: '###,###,###',
        cellTemplate: 'Cantidad',
        width: 100
      }, {
        dataField: 'Fecha',
        caption: 'Fecha',
        dataType: 'date',
        alignment: 'right',
        sortOrder: 'desc',
        width: 150,
        cellTemplate: function (cell, info) {
          let date = moment(info.data.Fecha).format('DD-MMM-YYYY')
          let res = date.split('-')
          res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
          cell.append(res.join('-'))
        }
      }, {
        dataField: 'Fecha',
        caption: 'Hora',
        alignment: 'right',
        allowSorting: false,
        allowFiltering: false,
        allowGrouping: false,
        width: 80,
        cellTemplate: function (cell, info) {
          let date = moment(info.data.Fecha).format('hh:mm:ss a')
          cell.append(date)
        }
      }],
      excelLoading: false,
      current: 1,
      items: 0,
      draft: {
        Id: this.$route.params.id,
        Type: 'asignaciones'
      }
    }
  },
  methods: {
    changePage (index) {
      this.current = index
    },
    exportExcel () {
      this.excelLoading = true
      let response = store.dispatch('distribuidorExcel', this.draft)
      response.then(response => {
        this.excelLoading = false
        window.open(response.data.url)
      })
    }
  },
  computed: {
    asignaciones () {
      return this.informacion
    },
    visible () {
      return this.informacion.length
    }
  },
  filters: {
    fecha (date) {
      return moment(date).format('DD-MMM-YYYY hh:mm:ss a')
    },
    name (str) {
      return (typeof str === 'undefined') ? str : (str.length > 24) ? str.substring(0, 22) + '...' : str
    },
    quantity (quan) {
      return (typeof quan === 'undefined') ? quan : quan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Historial/Asignaciones.vue